import { useEffect } from 'react';
import { marcarHomeListo, precargarImagen, cargarJson } from '../../../utils/arranque';
import { medirTinta } from '../../../utils/medirTinta';
import { colorArriba } from '../../../utils/colorArriba';
import { imagenBajoHeader } from '../../../hooks/useColorHeader';

const url = (u) => (!u ? null : u.startsWith('http') ? u : `https://${u}`);

// Lo que se ve en la primera pantalla del home, para tenerlo descargado antes
// de que se quite el splash. Lo de más abajo sigue cargando por demanda.
function primeraPantalla(restaurant, categorias) {
  const imagenes = [restaurant.headerBackground];
  const lotties = [];
  // Imágenes que además se MIDEN para acomodarse (ancho de cada pestaña según
  // su etiqueta, recorte de la etiqueta Bestseller): si la medida llega
  // después de mostrarse, se ve un brinco.
  const medir = [];
  const promo = restaurant.promoSection;

  if (promo?.isActive) {
    imagenes.push(promo.background);
    (promo.headerType === 'image' ? imagenes : lotties).push(promo.headerLottie);
    const tabs = [...(promo.tabs || [])].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
    tabs.forEach((t) => { imagenes.push(t.labelActive, t.labelInactive); medir.push(t.labelActive, t.labelInactive); });
    medir.push(promo.bestsellerImage);
    // Primeras tarjetas visibles (≈2.5 en pantalla): las de la primera
    // pestaña, o las sueltas si no hay pestañas.
    const ids = (tabs[0]?.products || promo.products || []).slice(0, 3).map(String);
    const porId = new Map(categorias.flatMap((c) => c.products).map((p) => [String(p._id || p.id), p]));
    ids.forEach((id) => { const p = porId.get(id); if (p) imagenes.push(p.popularImage || p.image); });
  } else {
    lotties.push(restaurant.promoBanner);
  }

  // Fotos de la barra de categorías (las primeras que caben).
  categorias.filter((c) => c.showInCategoryBar).slice(0, 5).forEach((c) => imagenes.push(c.image));

  const limpiar = (lista) => lista.map(url).filter(Boolean);
  return { imagenes: limpiar(imagenes), lotties: limpiar(lotties), medir: limpiar(medir) };
}

/**
 * Avisa al splash (utils/arranque.js) que el home ya se puede ver: con el
 * restaurante y el menú cargados (de la red o de la copia guardada), y con
 * las imágenes y Lotties de la primera pantalla ya descargados. El splash
 * tiene su propio tope, así que una imagen lenta no traba el arranque.
 */
export function useAvisarHomeListo({ activo, restaurant, menuCargando, categorias }) {
  useEffect(() => {
    if (!activo || !restaurant || menuCargando) return;
    const { imagenes, lotties, medir } = primeraPantalla(restaurant, categorias);
    Promise.all([
      ...imagenes.map(precargarImagen),
      ...lotties.map(cargarJson),
      ...medir.map(medirTinta),
      // El color del header sin imagen sale del fondo de la promo: medido
      // antes de quitar el splash, para que no cambie de color a la vista.
      colorArriba(imagenBajoHeader(restaurant)),
    ]).then(marcarHomeListo);
    // Basta la primera vez que hay datos: el aviso no se repite.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activo, !!restaurant, menuCargando]);
}
